<mat-select [value]="value" (selectionChange)="onSelectionChange($event)" (openedChange)="onOpenedChange($event)"
  [disabled]="isDisabled" [placeholder]="placeholder" panelClass="custom-select-panel" disableOptionCentering yPosition="below">
  <mat-select-trigger>
    <div style="display: flex; align-items: center;">
      @if(optionIconKey && getSelectedIcon()) {
        <span class="option-icon" [ngClass]="'dropdown-icon-' + value">
          <mat-icon class="material-symbols-outlined">{{ getSelectedIcon() }}</mat-icon>
        </span>
      }
      {{ getSelectedLabel() || placeholder }}
    </div>
  </mat-select-trigger>
  @for (item of items; track trackByOption($index, item)) {
    <mat-option [value]="getBindingValue(item)" [disabled]="isOptionDisabled(item)">
      <div style="display: flex; align-items: center;">
        @if (optionIconKey && hasOptionIcon(item)) {
          <span class="option-icon" [ngClass]="'dropdown-icon-' + getBindingValue(item)">
            <mat-icon class="material-symbols-outlined">{{ getOptionIcon(item) }}</mat-icon>
          </span>
        }
        <span class="option-label">{{ getDisplayValue(item) }}</span>
        @if (isOptionDisabled(item) && getDisabledReason(item)) {
          <span class="option-disabled-reason">({{ getDisabledReason(item) }})</span>
        }
      </div>
    </mat-option>
  }
</mat-select>
